import styled from 'styled-components'
import { FiArrowRight } from 'react-icons/fi'
import { useTypedSelector } from '../../../../../hooks'

interface PropInterface {
    hexCode: null | string
}
const ReportingChannelCardContainer = styled.div<PropInterface>`
    width: 95%;
    background: ${({ theme }) => theme.white};
    border-radius: 0.5rem;
    padding: 4rem;
    cursor: pointer;
    color: ${({ theme }) => theme.primary};
    transition: all 0.3s;
    height: 50%;
    &:hover {
        background: ${({ theme, hexCode }) =>
            hexCode ? hexCode : theme.primary};
        color: ${({ theme }) => theme.white};
    }

    @media (max-width: 1200px) {
        height: auto;
        width: 100%;
    }

    @media screen and (max-width: 600px) {
        min-height: 16rem;
    }
`
const TitleContainer = styled.div`
    display: flex;
    align-items: center;
    margin-top: 8rem;

    @media screen and (min-width: 1200px) and (max-width: 1600px) {
        margin-top: 6rem;
    }

    @media (max-width: 600px) {
        margin-top: 5rem;
    }
    &:hover .arrow-icon {
        color: white;
    }
`
const Title = styled.h2`
    font-size: 3.2rem;
    margin-right: 1rem;

    @media screen and (max-width: 600px) {
        font-size: 2.3rem;
    }

    @media screen and (max-width: 400px) {
        font-size: 2rem;
    }
`
const Tagline = styled.h4`
    font-size: 1.6rem;
    opacity: 0.5;
    padding-top: 1.5rem;
`

interface ReportingChannelCardProp {
    onClick: React.MouseEventHandler<HTMLDivElement>
    title: string
    tagline: string
}

const ReportingChannelCard: React.FC<ReportingChannelCardProp> = ({
    onClick,
    title,
    tagline,
}) => {
    const { hexCode } = useTypedSelector((state) => state.whitelabel)

    return (
        <ReportingChannelCardContainer onClick={onClick} hexCode={hexCode}>
            <TitleContainer>
                <Title>{title}</Title>
                <FiArrowRight color="arrow-icon" size={21} />
            </TitleContainer>
            <Tagline>{tagline}</Tagline>
        </ReportingChannelCardContainer>
    )
}

export default ReportingChannelCard
